import { Phone, MapPin, Instagram } from "lucide-react";
import { useLang } from "@/i18n";

const INSTA_LINK = "https://www.instagram.com/mahima_metal";

export default function Footer() {
  const { str } = useLang();
  return (
    <footer data-testid="footer" className="border-t border-white/10 bg-[#0A0A0A] px-6 sm:px-10 lg:px-16 py-12">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-8">
        <div className="flex flex-col items-start gap-3">
          <img src="/logo.png" alt="Mahima Metals" className="h-11 w-auto object-contain" />
          <p className="font-ticker text-[10px] tracking-[0.25em] uppercase text-white/35">
            {str.footerTagline}
          </p>
        </div>

        <div className="flex flex-col sm:flex-row gap-4 sm:gap-8 sm:items-center">
          <a
            href="tel:+918000093073"
            data-testid="footer-phone-link"
            className="inline-flex items-center gap-2 font-ticker text-xs tracking-[0.2em] text-[#25D366] hover:text-[#7BE3A6] transition-colors"
          >
            <Phone size={13} /> +91 80000 93073
          </a>
          <span className="inline-flex items-center gap-2 font-ticker text-xs tracking-[0.15em] text-white/45">
            <MapPin size={13} className="text-[#25D366]" /> Mahima Metals, Kim, Gujarat 394112
          </span>
          <a
            href={INSTA_LINK}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-instagram-link"
            aria-label="Follow on Instagram"
            className="inline-flex items-center gap-2 font-ticker text-xs tracking-[0.2em] text-white/55 hover:text-[#25D366] transition-colors"
          >
            <Instagram size={15} /> @mahima_metal
          </a>
        </div>
      </div>

      <div className="mt-10 pt-8 border-t border-white/5 flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
        <p className="font-ticker text-[10px] tracking-[0.2em] uppercase text-white/30">
          © {new Date().getFullYear()} Mahima Metals. {str.rights}
        </p>
        <p className="font-ticker text-[10px] tracking-[0.2em] uppercase text-white/30">
          {str.footerDisclaimer}
        </p>
      </div>
    </footer>
  );
}
